import { render, staticRenderFns } from "./AccommodationDetails.vue?vue&type=template&id=c33c6da2&"
import script from "./AccommodationDetails.vue?vue&type=script&lang=js&"
export * from "./AccommodationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports